import { InvitationStatus } from '@/types';

export interface ResidentialUnitFilterOptions {
    floors: string[];
    layoutTypes: string[];
    tags: number[];
    rooms: number[];
    groups: number[];
    searchText: string;
    soldStatus: 'all' | 'sold' | 'unsold';
    hasDeadline: number[];
    hasUnsentOptions: 'all' | 'yes' | 'no';
    buyerStatus: 'all' | InvitationStatus;
}

export class ResidentialUnitFilterOptions {
    static empty(): ResidentialUnitFilterOptions {
        return {
            floors: [],
            groups: [],
            layoutTypes: [],
            tags: [],
            rooms: [],
            searchText: '',
            soldStatus: 'all',
            hasDeadline: [],
            hasUnsentOptions: 'all',
            buyerStatus: 'all',
        };
    }
}

export { default } from './ResidentialUnitsFilter';
